// API base URL — habilita chamadas cross-origin no deploy workers.dev/pages.dev.
//
// Dev/test: VITE_API_BASE_URL ausente → '' → paths relativos (/api/...). Em dev
//   o Vite faz proxy (/api → :8787, ver vite.config). Em teste o fetch é mockado
//   com path relativo → continua casando.
// Produção pages.dev: VITE_API_BASE_URL = https://api.contatofacilites.workers.dev
//   → fetch absoluto. Front (canal-contato-facilites.pages.dev) e API ficam em
//   origens distintas; o CORS do Worker permite a origem do front.
//
// O presign devolve uploadUrl RELATIVA (/api/denuncia/attachments/upload?token=)
// — apiUrl() também a prefixa. O guard de URL absoluta deixa http(s) intactos.

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/** Prefixa `path` com a base da API (vazio em dev/test → path relativo). */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}
